export type ActivityState = 'active' | 'away' | 'offline' | 'unknown';
export interface ActivityLease { id: number; onlineUntil: number; activeUntil: number }
export interface ActivitySnapshot { leases: ActivityLease[]; expires: number }
export const IDLE_MS = 300_000;
export const HEARTBEAT_MS = 20_000;

export function parseActivitySnapshot(value: unknown, now: number): ActivitySnapshot {
  const data = (value as { data?: { connections?: unknown; valid_for_seconds?: unknown } })?.data;
  if (!data || !Array.isArray(data.connections) || data.connections.length > 10_000 ||
      data.valid_for_seconds !== 35) throw new Error('Invalid activity snapshot');
  const seen = new Set<number>();
  const leases = data.connections.map((row: { id: number; online_for: number; active_for: number }) => {
    if (!row || !Number.isSafeInteger(row.id) || row.id <= 0 || seen.has(row.id) ||
        !Number.isFinite(row.online_for) || row.online_for < 0 || row.online_for > 90 ||
        !Number.isFinite(row.active_for) || row.active_for < 0 || row.active_for > row.online_for)
      throw new Error('Invalid activity lease');
    seen.add(row.id);
    return { id: row.id, onlineUntil: now + row.online_for * 1000, activeUntil: now + row.active_for * 1000 };
  });
  return { leases, expires: now + 35_000 };
}

export function activityStates(snapshot: ActivitySnapshot | null, now: number): Map<number, ActivityState> | null {
  if (!snapshot || now >= snapshot.expires) return null;
  return new Map(snapshot.leases.filter(item => item.onlineUntil > now)
    .map(item => [item.id, item.activeUntil > now ? 'active' : 'away']));
}

export function activityPayload(session: string, lastAction: number, now: number, foreground: boolean) {
  return { session, foreground, idle_seconds: Math.min(300, Math.max(0, (now - lastAction) / 1000)) };
}
